<template>
  <div class="dropdown-menu">
    <a @click="toggle">{{ title }}</a>
    <div v-if="active" class="dropdown-items-wrapper">
      <template v-for="{ text, link, children, classes } in items">
        <h5 v-if="!link" :key="text" class="dropdown-item">
          {{ text }}
        </h5>

        <a
          v-if="link"
          :key="text"
          :href="generateLink(link)"
          :class="['dropdown-item', ...classes]"
        >
          {{ text }}
        </a>

        <a
          v-for="{ text, link, classes } in children"
          :key="text"
          :href="generateLink(link)"
          :class="['dropdown-item', ...classes]"
        >
          {{ text }}
        </a>
        <div v-if="children" :key="text" class="divider" />
      </template>
    </div>
  </div>
</template>

<script>
import { siteLink } from "@/constants/links";

export default {
  props: ["title", "items"],
  data() {
    return {
      active: false
    };
  },
  computed: {
    getLinkPrefix() {
      return this.$store.state.search.isMobile
        ? siteLink.mobile
        : siteLink.desktop;
    }
  },
  created: function() {
    window.addEventListener("click", this.closeDropdown);
  },
  methods: {
    toggle() {
      this.active = !this.active;
    },
    generateLink(link) {
      return this.getLinkPrefix + link;
    },
    closeDropdown(event) {
      if (!this.$el.contains(event.target)) {
        this.active = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.dropdown-menu {
  position: relative;
  color: $color-grey-500;
  white-space: nowrap;
  transition: all .35s;
  font-size: $font-size-nav;
  margin: 0 17px;
  padding: 0;

  & > a {
    display: block;
    cursor: pointer;

    &::after {
      content: "";
      display: inline-block;
      width: 0;
      height: 0;
      margin-left: 4px;
      vertical-align: middle;
      border-top: 4px dashed;
      border-top: 4px solid;
      border-right: 4px solid transparent;
      border-left: 4px solid transparent;
    }

    &:hover {
      color: $color-blue-300;
      opacity: .7;
    }
  }

  .dropdown-items-wrapper {
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translate(-50%, 0);
    display: flex;
    flex-direction: column;
    min-width: 160px;
    padding: 20px 0;
    margin-top: 24px;
    font-size: 14px;
    text-align: left;
    list-style: none;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ccc;
    box-shadow: 0 6px 12px rgba(0, 0, 0, .175);

    .dropdown-item {
      display: block;
      clear: both;
      color: #333;
      white-space: nowrap;
      font-weight: 400;
      line-height: 1.42857143;
      padding: 3px 20px 6px 20px;

      &.navigation-secondary {
        padding: 3px 20px 15px 20px;
        font: 700 14px/1.2 "HyundaiSansHead-Regular", sans-serif;
        color: #002c5f;

        &:last-of-type {
          padding-bottom: 0;
        }
      }

      &.green-ireland {
        color: limegreen;

        &::before {
          content: "";
          background-image: url("https://www.hyundai.ie/greener-ireland/img/hyundai-leaf.png");
          vertical-align: middle;
          width: 20px;
          height: 20px;
          display: inline-block;
        }
      }
    }

    h5 {
      margin: 0;

      &.dropdown-item {
        font: 700 14px/1.2 "HyundaiSansHead-Regular", sans-serif;
        color: #002c5f;
        padding: 10px 20px;
      }
    }
  }

  .divider:not(:last-of-type) {
    height: 1px;
    margin: 9px 0;
    overflow: hidden;
    background-color: #e5e5e5;
  }
}
</style>
